import { Controller } from "@hotwired/stimulus"

// Toggles a document iframe into browser-native fullscreen mode.
// Uses the Fullscreen API (requestFullscreen / exitFullscreen).
export default class extends Controller {
  static targets = ["container", "expandIcon", "compressIcon"]

  connect() {
    this.handleFullscreenChange = this.handleFullscreenChange.bind(this)
    document.addEventListener("fullscreenchange", this.handleFullscreenChange)
  }

  disconnect() {
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange)
  }

  toggle(event) {
    event.preventDefault()

    if (document.fullscreenElement) {
      document.exitFullscreen()
    } else if (this.hasContainerTarget) {
      this.containerTarget.requestFullscreen().catch(() => {
        // Fullscreen API unavailable -- fall back to opening blob URL in new tab
        const fallbackUrl = this.containerTarget.querySelector("iframe")?.src
        if (fallbackUrl) window.open(fallbackUrl, "_blank")
      })
    }
  }

  handleFullscreenChange() {
    const isFullscreen = !!document.fullscreenElement

    if (this.hasExpandIconTarget && this.hasCompressIconTarget) {
      this.expandIconTarget.classList.toggle("hidden", isFullscreen)
      this.compressIconTarget.classList.toggle("hidden", !isFullscreen)
    }
  }
}
